import { bind } from 'decko'
import { LiveElement } from 'live-node-list'
import Flickity from 'flickity'

export default class FormSuccessButton {
  /**
   * @type {LiveElement}
   */
  template = new LiveElement('.template-regen-report-2026')

  constructor() {
    this.registerListeners()
  }

  @bind
  registerListeners() {
    if (!this.template.item) {
      return
    }

    this.injectStyles()
  }

  @bind
  injectStyles() {
    var DEBUG = location.search.indexOf('debug') !== -1;
    function log() {
      if (DEBUG) console.log.apply(console, ['[regen-dl-btn]'].concat([].slice.call(arguments)));
    }

    var SEL = 'a:not(form a)';
    var CSS = SEL + '{'
      + 'display:inline-block;margin-top:.75em;padding:.45em 1.25em .5em;'
      + 'border-radius:var(--button-border-radius,20px);'
      + 'background:var(--button-background-color,var(--foreground));'
      + 'color:var(--button-text-color,var(--background))!important;'
      + 'font-weight:700;text-transform:uppercase;text-decoration:none!important;'
      + 'line-height:1.2;text-align:center;transition:opacity .2s ease;}'
      + SEL + ':hover{opacity:.85;}';

    function style(embed) {
      if (!embed.shadowRoot) { log('embed found but no shadowRoot yet'); return; }
      if (embed.dataset.dlBtn) return;
      var s = document.createElement('style');
      s.textContent = CSS;
      embed.shadowRoot.appendChild(s);
      embed.dataset.dlBtn = '1';
      log('injected styles into shadow root, matching', SEL);
    }

    function scan(tries) {
      var embeds = document.querySelectorAll('shopify-forms-embed');
      var pending = false;
      embeds.forEach(function (e) { if (e.shadowRoot) { style(e); } else { pending = true; } });
      if ((pending || !embeds.length) && tries > 0) {
        setTimeout(function () { scan(tries - 1); }, 100);
      } else {
        log('done. embeds found:', embeds.length);
      }
    }

    scan(50); // poll up to ~5s for the embed's shadow root to attach
  }
}
